import Checkmark from '../../../assets/checkmark.svg';

const CheckmarkIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Checkmark data-testid="check-mark-icon" {...props} />;
};

export default CheckmarkIcon;
